<template>
  <div id="dashboard-lom-president" class="premium-dashboard-wrapper">
    <overlay-loading-progress :LoadingFlag="LoadingFlag" />



    <v-container fluid class="main-content-container py-0 px-6">
      <!-- Skeleton Loaders -->
      <v-row v-if="StartupLoadingFlag">
        <v-col cols="12" md="4" v-for="n in 3" :key="n">
          <v-card class="premium-card pa-6">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>

      <div v-if="!LoadingFlag && ResultFlag" class="dashboard-body">
        <!-- Quick Insight Stats -->
        <v-row class="mb-8 px-4">
          <v-col cols="12" md="3">
            <v-card class="stat-card zvp-premium-card pa-4 h-100" dark>
              <div class="d-flex justify-space-between align-start">
                <div>
                  <div class="text-overline mb-1 opacity-70">Organization</div>
                  <div class="text-h5 font-weight-bold mb-1">LO CODE</div>
                  <div class="text-h4 font-weight-black gold--text">{{ rows.MemberLoCode }}</div>
                </div>
                <v-avatar size="56" color="rgba(255,255,255,0.2)">
                  <v-icon large color="white">mdi-identifier</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="stat-card ldmt-premium-card pa-4 h-100" dark>
              <div class="d-flex justify-space-between align-start">
                <div>
                  <div class="text-overline mb-1 opacity-70">Area Context</div>
                  <div class="text-h5 font-weight-bold mb-1">{{ rows.AreaName }}</div>
                  <div class="text-body-2">National Organization</div>
                </div>
                <v-avatar size="56" color="rgba(255,255,255,0.2)">
                  <v-icon large color="white">mdi-earth-box</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="stat-card lav-premium-card pa-4 h-100" dark>

              <div class="d-flex justify-space-between align-start">
                <div>
                  <div class="text-overline mb-1 opacity-70">Zone Status</div>
                  <div class="text-h5 font-weight-bold mb-1">{{ rows.ZoneName }}</div>
                  <div class="text-body-2">{{ rows.RegionName }}</div>
                </div>
                <v-avatar size="56" color="rgba(255,255,255,0.2)">
                  <v-icon large color="white">mdi-map-clock-outline</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="stat-card ldmt-premium-card pa-4 h-100" dark>
              <div class="d-flex justify-space-between align-start">
                <div>
                  <div class="text-overline mb-1 opacity-70">Local Organization</div>
                  <div class="text-h5 font-weight-bold mb-1">LO NAME</div>
                  <div class="text-h5 font-weight-black gold--text">{{ rows.LomName }}</div>
                </div>
                <v-avatar size="56" color="rgba(255,255,255,0.2)">
                  <v-icon large color="white">mdi-shield</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <!-- Left Column: Profile & Growth -->
          <v-col cols="12" lg="8">
            <!-- President Profile Card -->
            <v-card class="lom-details-card mb-8 overflow-hidden">
              <v-row no-gutters>
                <v-col cols="12" md="4" class="pa-8 d-flex flex-column align-center border-right-md bg-light-gradient">
                  <v-avatar size="200" class="elevation-12 profile-avatar-premium mb-6">
                    <v-img :src="rows.ProfilePic">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="navy"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                  <v-btn block class="premium-nav-btn edit-btn mt-4">
                    EDIT PROFILE
                  </v-btn>
                  <v-btn block class="premium-nav-btn logout-btn mt-4" @click="LogoutUser">
                    <v-icon left>mdi-power</v-icon> TERMINATE SESSION
                  </v-btn>
                </v-col>
                <v-col cols="12" md="8" class="pa-8">
                  <h2 class="section-title mb-8">{{ rows.RoleName }} Identity</h2>
                  <v-row>
                    <v-col cols="12" md="6" v-for="(item, index) in rows.MemberDetails" :key="index" class="py-2">
                      <div class="info-item">
                        <div class="text-overline">{{ item.MemberFieldName }}</div>
                        <div class="text-body-1 font-weight-bold">{{ item.MemberFieldValue }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>

            <!-- Growth Metrics Section -->
            <v-card class="admin-premium-card mb-8">
              <div class="admin-premium-header d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-icon color="white" large class="mr-3">mdi-chart-line</v-icon>
                  <div>
                    <h3 class="text-h5 font-weight-bold white--text mb-0">Growth Trajectory</h3>
                    <div class="text-caption white--text opacity-70">Excluding JAC Members</div>
                  </div>
                </div>
              </div>
              <v-data-table :headers="rows.TableHeader1" :items="rows.TableData1" hide-default-footer
                class="metric-table">
                <template v-slot:[`item.Growth`]="{ item }">
                  <v-chip :color="item.Color" dark class="custom-chip">
                    {{ item.Growth }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <!-- Right Column: Voting & Actions -->
          <v-col cols="12" lg="4">
            <!-- Voting Pulse -->
            <v-card v-if="rows.VotingCardFlag" class="stat-card zvp-premium-card pa-6 mb-8 overflow-hidden" dark>
              <div class="header-bubbles opacity-20">
                <div class="bubble b-1"></div>
                <div class="bubble b-2"></div>
              </div>
              <div class="d-flex align-center mb-6" style="position: relative; z-index: 2;">
                <v-icon large class="mr-3 gold--text">mdi-vote-outline</v-icon>
                <h3 class="text-h5 font-weight-bold white--text">Voting Rights</h3>
              </div>
              <div class="bg-white rounded-xl pa-4" style="position: relative; z-index: 2;">
                <voting-count></voting-count>
              </div>
            </v-card>

            <!-- Command Center Links -->
            <v-card class="admin-premium-card mb-8">
              <div class="admin-premium-header d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-icon color="white" large class="mr-3">mdi-view-dashboard</v-icon>
                  <h3 class="text-h5 font-weight-bold white--text mb-0">Quick Links</h3>
                </div>
              </div>
              <div class="pa-6">
                <v-row dense>
                  <v-col cols="12" v-for="item in rows.QuickLinks" :key="item.LinkId" class="mb-3">
                    <v-btn v-if="item.LinkUrl.includes('http')" :href="item.LinkUrl" target="_blank" block large
                      class="premium-btn action-link-btn" :style="`--link-color: ${item.LinkColor}`">
                      <span class="btn-text-content">{{ item.LinkTxt }}</span>
                      <v-spacer></v-spacer>
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                    <router-link v-else :to="item.LinkUrl" class="text-decoration-none w-100">
                      <v-btn block large class="premium-btn action-link-btn" :style="`--link-color: ${item.LinkColor}`">
                        <span class="btn-text-content">{{ item.LinkTxt }}</span>
                        <v-spacer></v-spacer>
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </router-link>
                  </v-col>
                </v-row>
              </div>
            </v-card>

            <!-- MRF Compliance -->
            <v-card class="admin-premium-card">
              <div class="admin-premium-header d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-icon color="white" large class="mr-3">mdi-file-document</v-icon>
                  <h3 class="text-h5 font-weight-bold white--text mb-0">MRF Compliance</h3>
                </div>
              </div>
              <div class="pa-6">
                <v-row dense>
                  <v-col cols="12" v-for="item in rows.MrfTable" :key="item.LinkId" class="mb-3">
                    <v-btn v-if="item.LinkUrl.includes('http')" :href="item.LinkUrl" target="_blank" block large
                      class="premium-btn action-link-btn" :style="`--link-color: ${item.LinkColor}`">
                      <span class="btn-text-content">{{ item.LinkTxt }}</span>
                    </v-btn>
                    <router-link v-else :to="item.LinkUrl" class="text-decoration-none w-100">
                      <v-btn block large class="premium-btn action-link-btn" :style="`--link-color: ${item.LinkColor}`">
                        <span class="btn-text-content">{{ item.LinkTxt }}</span>
                      </v-btn>
                    </router-link>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- National Calendar -->
        <v-row class="mt-8">
          <v-col cols="12">
            <v-card class="admin-premium-card overflow-hidden">
              <div class="admin-premium-header">
                <div class="d-flex align-center">
                  <v-icon color="white" large class="mr-3">mdi-calendar-star</v-icon>
                  <h3 class="text-h5 font-weight-bold white--text">National Engagement Calendar</h3>
                </div>
              </div>
              <div class="pa-8 bg-white">
                <dashboard-calendar :rows="rows" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <div class="page-footer py-10 text-center grey--text text--lighten-1">
      <div class="text-overline opacity-50">JCI India Enterprise Resource Planning v2.0</div>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import DashboardCalendar from "@/view/pages/erp/dashboard/DashboardCalender.vue";
import VotingCount from "@/view/pages/erp/lom/lom-information/VotingCount.vue";

export default {
  mixins: [common],
  name: "DashboardDashboard",
  components: {
    DashboardCalendar,
    VotingCount,
  },
  data() {
    return {
      LoadingFlag: false,
      StartupLoadingFlag: false,

      rows: {
        Chart1: {},
        ChartData1: {},
        TableBgColor1: "",
        TableBgColor2: "",
        TableBgColor3: "",
        TableBgColor4: "",
        TableBgColor5: "",
        ChartOptions1: {},
        Table1: {
          Title: "",
          Description: "",
        },
        TableHeader1: [],
        TableData1: [],
        Table2: {
          Title: "",
          Description: "",
        },
        TableHeader2: [],
        TableData2: [],
        EventsData: [],
        MemberLoCode: "0000",
      },
      ResultFlag: false,
      selected1: [],
      search1: "",

      itemsPerPage: 4,
      items: [
        { name: "Frozen Yogurt" },
        { name: "Ice cream sandwich" },
        { name: "Eclair" },
        { name: "Cupcake" },
      ],

      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({ tension: 0 }),
          low: 0,
          high: 50,
          chartPadding: { top: 0, right: 0, bottom: 0, left: 0 },
        },
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({ tension: 0 }),
          low: 0,
          high: 1000,
          chartPadding: { top: 0, right: 0, bottom: 0, left: 0 },
        },
      },
      emailsSubscriptionChart: {
        data: {
          labels: ["2020 - I", "2020 - II", "2021 - I", "2020 - II"],
          series: [[25, 30, 28, 40]],
        },
        ChartOptions1: {
          axisX: { showGrid: false },
          low: 0,
          high: 100,
          chartPadding: { top: 0, right: 5, bottom: 0, left: 0 },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      headers: [
        { sortable: false, text: "Year", value: "Year", align: "center" },
        { sortable: false, text: "First Half", value: "FirstHalf", align: "center" },
        { sortable: false, text: "Second Half", value: "SecondHalf", align: "center" },
      ],
      MembersColumn: [
        { sortable: false, text: "Photo", value: "Photo", align: "center" },
        { sortable: false, text: "Name", value: "Name", align: "center" },
        { sortable: false, text: "Designation", value: "Designation", align: "center" },
      ],
      MembersData: [
        { Photo: "mani.jpg", Name: "Mani", Designation: "VP" },
        { Photo: "raj.jpg", Name: "Raj", Designation: "VP" },
      ],
      tabs: 0,
      tasks: {
        0: [
          { text: 'Sign contract for "What are conference organizers afraid of?"', value: true },
          { text: "Lines From Great Russian Literature? Or E-mails From My Boss?", value: false },
          { text: "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit", value: false },
          { text: "Create 4 Invisible User Experiences you Never Knew About", value: true },
        ],
        1: [
          { text: "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit", value: true },
          { text: 'Sign contract for "What are conference organizers afraid of?"', value: false },
        ],
        2: [
          { text: "Lines From Great Russian Literature? Or E-mails From My Boss?", value: false },
          { text: "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit", value: true },
          { text: 'Sign contract for "What are conference organizers afraid of?"', value: true },
        ],
      },
      list: { 0: false, 1: false, 2: false },
      focus: "",
      type: "month",
      typeToLabel: { month: "Month", week: "Week", day: "Day", "4day": "4 Days" },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
      names: ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"],
    };
  },
  watch: {
    rows: function () {
      console.log("watch rows");
    },
  },
  mounted() {
    if (this.$refs.calendar) {
      this.$refs.calendar.checkChange();
    }
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
    refreshPageData() {
      this.getTableRecords();
    },
    getTableRecords() {
      var LomCode = 1;
      if (LomCode != null) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/dashboard/user/lom-president";
        var upload = { UserInterface: 1 };

        const thisIns = this;
        this.StartupLoadingFlag = true;
        this.LoadingFlag = true;
        this.ResultFlag = false;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.StartupLoadingFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.ResultFlag = true;

            var flag = response.data.flag;
            var records = response.data.records;

            if (flag == 1) {
              thisIns.rows = records;
              thisIns.toast("success", response.data.output);
            } else {
              thisIns.toast("error", response.data.output);
            }
          })
          .catch(function (error) {
            thisIns.toast("error", error);
            thisIns.StartupLoadingFlag = false;
            thisIns.LoadingFlag = false;
          });
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getDetailIcon(name) {
      const mapping = {
        'Name': 'mdi-account-tie',
        'Membership Id': 'mdi-card-bulleted-outline',
        'DOB': 'mdi-calendar',
        'Mobile No': 'mdi-phone',
        'Email': 'mdi-email-variant'
      };
      return mapping[name] || 'mdi-information-outline';
    }
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,700;1,400&display=swap');

#dashboard-lom-president {
  /* Premium Design Tokens from Report Page */
  --navy: #3A67B1;
  --aqua: #0097D7;
  --gold: #EDBE38;
  --seaform: #56BDA3;
  --text-90: #414042;
  --text-off-black: #0A0F29;
  --white: #FFFFFF;
  --light-bg: #FFFFFF;

  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 1.15rem !important;
  color: var(--text-off-black);

  .text-h3 {
    font-family: 'Lora', serif !important;
  }

  .text-h5 {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
  }

  .main-content-container {
    position: relative;
    z-index: 1;
  }

  .stat-card {
    border-radius: 24px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border: none !important;
    position: relative;
    overflow: hidden;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
    }

    &.zvp-premium-card {
      background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%) !important;
    }

    &.ldmt-premium-card {
      background: linear-gradient(135deg, #56BDA3 0%, #3A67B1 100%) !important;
    }

    &.lav-premium-card {
      background: linear-gradient(135deg, #0097D7 0%, #3A67B1 100%) !important;
    }

    &.premium-card {
      background: #FFFFFF !important;
      border: 1px solid rgba(10, 15, 41, 0.1) !important; // Off-black tint
    }
  }

  // Premium Cards (Light Glassmorphism)
  .glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(20px) saturate(160%);
    border: 1px solid rgba(255, 255, 255, 0.6) !important;
    border-radius: 32px !important;
    box-shadow: 0 10px 40px -10px rgba(10, 15, 41, 0.05) !important;
    position: relative;
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);

    &:hover {
      background: rgba(255, 255, 255, 0.9) !important;

      .glass-shine {
        transform: translateX(100%);
      }
    }

    .glass-shine {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      transition: transform 1.2s ease;
    }

    &.president-details-card {
      border-top: 6px solid var(--navy) !important;
    }

    &.voting-card {
      border-top: 6px solid var(--gold) !important;
    }
  }

  // Profile Section
  .lom-details-card {
    background: var(--white) !important;
    border-radius: 28px !important;
    border-left: 10px solid var(--navy) !important;
    box-shadow: 0 15px 40px rgba(10, 15, 41, 0.08) !important;
    overflow: hidden;
  }

  .profile-avatar-premium {
    border: 6px solid var(--white);
    box-shadow: 0 12px 30px rgba(10, 15, 41, 0.15) !important;
  }

  .info-item {
    .text-overline {
      color: var(--text-90) !important;
      opacity: 0.6;
      font-weight: 800;
      letter-spacing: 1px;
    }

    .text-body-1 {
      color: var(--navy) !important;
      font-size: 1.15rem !important;
    }
  }

  // Admin Premium Cards
  .admin-premium-card {
    background: var(--white) !important;
    border-radius: 28px !important;
    border: 1px solid rgba(10, 15, 41, 0.08) !important;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.05) !important;
    overflow: hidden;

    .admin-premium-header {
      background: linear-gradient(135deg, var(--navy) 0%, var(--aqua) 100%) !important;
      padding: 24px 28px !important;
    }
  }

  .bg-light-gradient {
    background: linear-gradient(180deg, rgba(10, 15, 41, 0.02) 0%, var(--white) 100%);
  }

  .border-right-md {
    border-right: 1px solid rgba(10, 15, 41, 0.05);
  }

  .border-bottom {
    border-bottom: 1px solid rgba(10, 15, 41, 0.05);
  }

  // Matrix Buttons
  .action-link-btn {
    background: var(--white) !important;
    border: 1px solid rgba(10, 15, 41, 0.1) !important;
    color: var(--text-off-black) !important;
    border-left: 5px solid var(--link-color, #3A67B1) !important;
    border-radius: 16px !important;
    transition: all 0.3s ease !important;

    .v-btn__content {
      justify-content: flex-start !important;
      width: 100%;
    }

    &:hover {
      background: rgba(10, 15, 41, 0.02) !important;
      transform: translateX(5px);
    }
  }

  .premium-btn {
    text-transform: none !important;
    letter-spacing: 0.8px !important;
    font-weight: 700 !important;
    border-radius: 16px !important;
    height: 52px !important;

    &.btn-search {
      background: var(--gold) !important;
      color: var(--text-off-black) !important;
    }
  }

  .main-title {
    font-size: 2.2rem;
    font-weight: 800;
    letter-spacing: -1.5px;
    background: linear-gradient(135deg, var(--text-off-black) 0%, var(--navy) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .section-title {
    font-size: 1.4rem;
    font-weight: 800;
    letter-spacing: -0.5px;
    color: var(--text-off-black);
  }

  .subtitle-badge {
    display: inline-block;
    padding: 6px 14px;
    background: rgba(0, 151, 215, 0.1);
    color: var(--navy);
    border-radius: 10px;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  .note-badge {
    font-size: 0.75rem;
    color: var(--seaform);
    background: rgba(86, 189, 163, 0.1);
    padding: 6px 14px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    font-weight: 700;
  }

  // Header Banner Styling
  .premium-header-card {
    background: linear-gradient(135deg, var(--navy) 0%, var(--aqua) 100%) !important;
    border-radius: 0 0 40px 40px !important;
    box-shadow: 0 15px 40px rgba(58, 103, 177, 0.3) !important;
    position: relative;
    overflow: hidden !important;
    z-index: 2;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -20%;
      width: 400px;
      height: 400px;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 50%;
    }
  }

  .header-bubbles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
  }

  .bubble {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.02));
    animation: float-bubble 15s infinite ease-in-out;
  }

  .b-1 {
    width: 120px;
    height: 120px;
    top: -20%;
    left: 10%;
    animation-delay: 0s;
  }

  .b-2 {
    width: 80px;
    height: 80px;
    top: 60%;
    left: 80%;
    animation-delay: -2s;
  }

  .b-3 {
    width: 200px;
    height: 200px;
    top: 40%;
    left: 20%;
    animation-delay: -5s;
  }

  .b-4 {
    width: 150px;
    height: 150px;
    top: -10%;
    left: 40%;
    animation-delay: -8s;
  }

  .b-5 {
    width: 60px;
    height: 60px;
    top: 50%;
    left: 60%;
    animation-delay: -3s;
  }

  @keyframes float-bubble {

    0%,
    100% {
      transform: translateY(0) translateX(0) scale(1);
    }

    33% {
      transform: translateY(-20px) translateX(10px) scale(1.1);
    }

    66% {
      transform: translateY(10px) translateX(-15px) scale(0.9);
    }
  }

  .premium-action-btn {
    border-radius: 100px !important;
    text-transform: none !important;
    font-weight: 800 !important;
    letter-spacing: 0.5px !important;
    position: relative;
    z-index: 2;

    &.refresh-btn {
      background: linear-gradient(135deg, var(--navy) 0%, var(--aqua) 100%) !important;
      color: var(--white) !important;
      padding: 0 48px !important;
      box-shadow: 0 10px 25px rgba(58, 103, 177, 0.2) !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 35px rgba(58, 103, 177, 0.3) !important;
      }
    }
  }

  .icon-pulse {
    animation: rotate-pulse 4s infinite linear;
  }

  @keyframes rotate-pulse {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .avatar-container {
    position: relative;
    padding: 15px;

    .profile-avatar {
      border-radius: 35px;
      border: 6px solid var(--white);
      box-shadow: 0 10px 30px rgba(10, 15, 41, 0.1);
      position: relative;
      z-index: 2;
    }

    .avatar-glow {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 130%;
      height: 130%;
      background: radial-gradient(circle, rgba(0, 151, 215, 0.1) 0%, transparent 70%);
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }

  .details-table-wrapper {
    .modern-data-table {
      background: transparent !important;
      color: var(--text-90) !important;

      tr {
        background: transparent !important;
      }

      td {
        background: transparent !important;
        border-bottom: 1px solid rgba(10, 15, 41, 0.05) !important;
        padding: 18px !important;
        font-size: 1.05rem !important;
        font-weight: 600;
        color: var(--text-90) !important;
      }

      tr:hover {
        background: rgba(58, 103, 177, 0.02) !important;
      }
    }
  }

  .voting-wrapper {
    .v-card {
      background: rgba(255, 255, 255, 0.5) !important;
      border: 1px solid rgba(10, 15, 41, 0.05) !important;
      color: var(--text-off-black) !important;
      box-shadow: none !important;
    }

    div[style*="background-color: white"],
    div[style*="background-color: rgb(255, 255, 255)"],
    .white {
      background-color: rgba(58, 103, 177, 0.05) !important;
      color: var(--text-off-black) !important;
      border-radius: 12px;
    }

    span,
    h1,
    h2,
    h3,
    p {
      color: var(--text-off-black) !important;
    }
  }

  .premium-data-grid {
    background: transparent !important;

    th {
      background: rgba(58, 103, 177, 0.03) !important;
      color: var(--navy) !important;
      font-weight: 800 !important;
      text-transform: uppercase !important;
      letter-spacing: 1.2px !important;
      font-size: 0.75rem !important;
      border-bottom: 2px solid var(--aqua) !important;
    }

    td {
      border-bottom: 1px solid rgba(10, 15, 41, 0.03) !important;
      color: var(--text-90) !important;
      font-weight: 600;
      height: 75px !important;
    }

    tr:hover {
      background: rgba(58, 103, 177, 0.02) !important;
    }
  }

  .growth-chip {
    font-weight: 800 !important;
    font-size: 0.8rem !important;
    border-radius: 10px !important;
    padding: 0 18px !important;
    color: var(--white) !important;
    box-shadow: 0 4px 12px rgba(0, 151, 215, 0.2);
  }

  .premium-nav-btn {
    text-transform: none !important;
    font-weight: 800 !important;
    border-radius: 18px !important;
    height: 52px !important;
    padding: 0 28px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &.edit-btn {
      background: rgba(0, 151, 215, 0.1) !important;
      color: var(--navy) !important;
      border: 2px solid rgba(0, 151, 215, 0.2) !important;

      &:hover {
        background: var(--aqua) !important;
        color: var(--white) !important;
        border-color: var(--aqua) !important;
      }
    }

    &.logout-btn {
      background: rgba(58, 103, 177, 0.08) !important;
      color: #3A67B1 !important;
      border: 2px solid rgba(58, 103, 177, 0.2) !important;

      &:hover {
        background: #3A67B1 !important;
        color: #FFFFFF !important;
        border-color: #3A67B1 !important;
      }
    }
  }

  .matrix-btn {
    background: var(--white) !important;
    border: 1px solid rgba(10, 15, 41, 0.08) !important;
    border-radius: 22px !important;
    height: 68px !important;
    color: var(--text-off-black) !important;
    text-transform: none !important;
    font-weight: 800 !important;
    justify-content: flex-start !important;
    padding: 0 26px !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(10, 15, 41, 0.03) !important;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 100%;
      background: var(--accent-color);
      opacity: 0.9;
    }

    &:hover {
      background: var(--white) !important;
      border-color: var(--accent-color) !important;
      transform: translateX(12px) scale(1.02);
      box-shadow: 0 12px 24px rgba(10, 15, 41, 0.08) !important;

      .btn-text {
        color: var(--accent-color);
      }
    }
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    .loader-content {
      text-align: center;

      .premium-spinner {
        width: 80px;
        height: 80px;
        border: 4px solid rgba(58, 103, 177, 0.1);
        border-top: 4px solid var(--navy);
        border-radius: 50%;
        animation: spin 1s infinite cubic-bezier(0.5, 0.1, 0.5, 0.9);
        margin-bottom: 24px;
      }

      .loading-text {
        color: var(--navy);
        font-weight: 800;
        letter-spacing: 5px;
        font-size: 0.85rem;
      }
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .page-transition-enter-active {
    animation: dashboard-entrance 1.2s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  }

  @keyframes dashboard-entrance {
    from {
      opacity: 0;
      transform: translateY(40px) scale(0.98);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .page-footer {
    height: 24px;
  }

  .location-breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: var(--text-90);
    font-weight: 700;
    font-size: 0.95rem;

    .segment {
      transition: color 0.3s ease;
    }

    .active-segment {
      color: var(--navy);
    }

    .separator {
      color: rgba(10, 15, 41, 0.2);
    }
  }

  .lo-code-widget {
    background: var(--white) !important;
    padding: 10px 24px !important;
    border-radius: 16px !important;
    border: 2px solid var(--navy) !important;
    box-shadow: 0 4px 12px rgba(58, 103, 177, 0.1) !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 120px;

    .widget-label {
      font-size: 0.75rem !important;
      color: var(--navy) !important;
      font-weight: 800 !important;
      letter-spacing: 2px !important;
      text-transform: uppercase !important;
      opacity: 0.8;
      margin-bottom: 4px !important;
      white-space: nowrap !important;
      line-height: 1 !important;
    }

    /* Data Table Styling */
    .metric-table {
      th {
        font-weight: 800 !important;
        color: #3A67B1 !important;
        text-transform: uppercase;
        font-size: 0.9rem !important;
        letter-spacing: 1.2px;
        padding: 20px !important;
        background: #FFFFFF !important;
      }

      td {
        padding: 20px !important;
        font-size: 1.1rem !important;
        color: #414042 !important;
      }
    }

    .widget-value {
      font-size: 2rem !important;
      color: var(--navy) !important;
      font-weight: 900 !important;
      line-height: 1 !important;
      letter-spacing: 1px !important;
    }
  }

  .profile-details-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    .detail-item {
      display: flex;
      align-items: center;
      padding: 14px 20px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 16px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      transition: all 0.3s ease;

      &:first-child {
        grid-column: span 2;
        background: rgba(255, 255, 255, 0.6);
        border-color: rgba(58, 103, 177, 0.2);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.8);
        transform: translateY(-5px);
        box-shadow: 0 12px 25px rgba(58, 103, 177, 0.08);
      }

      .detail-icon {
        width: 44px;
        height: 44px;
        background: white;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      }

      .detail-content {
        flex: 1;

        .detail-label {
          font-size: 0.7rem;
          font-weight: 800;
          color: var(--jci-navy);
          text-transform: uppercase;
          letter-spacing: 1.5px;
          opacity: 0.5;
          margin-bottom: 2px;
        }

        .detail-value {
          font-size: 1.25rem;
          font-weight: 800;
          color: var(--jci-off-black);
          letter-spacing: -0.5px;
        }
      }
    }
  }

  // Voting Card Extra
  .icon-square {
    width: 52px;
    height: 52px;
    background: var(--jci-gold);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(237, 190, 56, 0.25);
  }

  // Calendar Components Overrides
  .calendar-card {
    .header-decoration {
      width: 10px;
      height: 45px;
      background: var(--jci-navy);
      border-radius: 5px;
    }
  }

  .glass-divider {
    border-color: rgba(10, 15, 41, 0.05) !important;
  }
}

// Data table global overrides for this page
.v-application .premium-data-grid .v-data-table__wrapper {
  background: transparent !important;
}

// Ensure table text is visible and sharp
.modern-data-table td,
.premium-data-grid td {
  color: var(--jci-90-black) !important;
}

// Global reset to remove any white border around the app container
.v-application {
  background-color: transparent !important;
}

// Layout Footer Fix
.footer,
#kt_footer {
  background-color: transparent !important;
  position: relative !important;
  z-index: 10 !important;
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  box-shadow: none !important;
}
</style>